import moment from 'moment';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import '../../common/bn-icon';

class DeviceSensorErrorCount extends LitEntity {
  static get properties() {
    return {
      errorsFound: { type: Number, attribute: false },
      eventsHref: { type: String, attribute: false },
      eventsCount: { type: Number, attribute: false },
      dateDifferenceDays: { type: Number, attribute: false },
    };
  }

  static get styles() {
    return css`
      :host {
        display: flex;
        align-items: flex-end;
      }
      bn-icon {
        margin-right: .25em;
      }
    `;
  }

  render() {
    return html`
      <lit-entity @update="${this._onEventsUpdate}" .href="${this.eventsHref}" ></lit-entity>
      ${renderIf(this.eventsCount === undefined, html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon> Loading`)}
      ${renderIf(this.eventsCount === 0, html`No readings in the past ${this.dateDifferenceDays} days`)}
      ${renderIf(this.eventsCount > 0, html`${this.errorsFound || 0} in the past ${this.dateDifferenceDays} days`)}
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.eventsHref = this.getHref('https://api.binsentry.com/rel/events');
  }

  _onEventsUpdate(e) {
    const { entity } = e.detail;
    if (!entity || !entity.entities) {
      return;
    }

    let foundErrors = 0;
    for (let i = 0; i < entity.entities.length; i++) {
      if (entity.entities[i].properties.sensorCriticalError) {
        foundErrors++;
      }
    }

    this.errorsFound = foundErrors;
    this.eventsCount = entity.entities.length;
    this.dateDifferenceDays = moment(entity.properties.endDate).diff(moment(entity.properties.startDate), 'days');
  }
}

window.customElements.define('device-sensor-error-count', DeviceSensorErrorCount);
